import type { Components, Theme } from '@mui/material';

export const MuiFilledInput: Components<Omit<Theme, 'components'>>['MuiFilledInput'] = {
  defaultProps: {
    disableUnderline: true,
    hiddenLabel: true,
    sx: theme => ({
      backgroundColor: theme.palette.action.hover,
      borderRadius: '12px',
      paddingLeft: '12px',
    }),
  },
};